function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckboxIntermediate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "var(--highlight)"
    },
    d: "M0 10h24v4h-24z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxIntermediate);
export default __webpack_public_path__ + "static/media/checkbox-intermediate.c055240c7c6e10e33c011fe46d5b53ec.svg";
export { ForwardRef as ReactComponent };